var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import React, { useMemo, useLayoutEffect, useEffect, useRef, useState } from 'react';
import { createFilter } from 'react-select';
import { VariableSizeList as List } from 'react-window';
import { Box } from '../';
var Item = function (_a) {
    var children = _a.children, index = _a.index, setItemHeights = _a.setItemHeights, lss = _a.lss;
    var ref = React.useRef(null);
    // using useLayoutEffect prevents bounciness of options of re-renders
    useLayoutEffect(function () {
        if (ref.current) {
            var height = ref.current.getBoundingClientRect().height;
            setItemHeights({ index: index, height: height });
        }
    }, [setItemHeights, index]);
    return (React.createElement(Box, { key: "option-" + index, ref: ref, lss: __assign(__assign({}, lss), { height: 'auto' }) }, children));
};
export var OptimizedMenuList = function (props) {
    var options = props.options, children = props.children, getValue = props.getValue, innerRef = props.innerRef, isMulti = props.isMulti, getStyles = props.getStyles, _a = props.selectProps, classNamePrefix = _a.classNamePrefix, getOptionValue = _a.getOptionValue;
    var listRef = useRef(null);
    var itemCount = (Array.isArray(children) && children.length) || 1;
    var defaultHeights = Array.from({ length: itemCount }).map(function () { return 35; });
    var _b = __read(useState(defaultHeights), 2), itemHeights = _b[0], setItemHeights = _b[1];
    // resizes the menu list based on shown options
    useEffect(function () {
        setItemHeights(Array.from({ length: itemCount }).map(function () { return 35; }));
    }, [itemCount]);
    var _c = __read(getValue(), 1), value = _c[0];
    var initialOffset = useMemo(function () {
        // in multi doesn't make sense to auto scroll into the selected option
        // as we have multiple values
        if (isMulti)
            return 0;
        var optionValue = value && getOptionValue ? getOptionValue(value) : null;
        if (!optionValue)
            return 0;
        var offsetIndex = options.findIndex(function (option) { return getOptionValue && getOptionValue(option) === optionValue; });
        return itemHeights.reduce(function (sum, height, index) { return (index >= offsetIndex ? sum : sum + height); }, 0);
    }, [value, itemHeights, isMulti, getOptionValue, options]);
    var totalMenuHeight = itemHeights.reduce(function (sum, height) { return sum + height; }, 0);
    var _d = getStyles('menuList', props), maxHeight = _d.maxHeight, _e = _d.paddingBottom, paddingBottom = _e === void 0 ? 0 : _e, _f = _d.paddingTop, paddingTop = _f === void 0 ? 0 : _f, menuListStyle = __rest(_d, ["maxHeight", "paddingBottom", "paddingTop"]);
    var handleSetItemHeights = function (_a) {
        var index = _a.index, height = _a.height;
        if (itemHeights[index] !== undefined && itemHeights[index] === height) {
            return;
        }
        setItemHeights(function (prevState) {
            var newState = __spread(prevState);
            newState[index] = height;
            return newState;
        });
        // this forces the list to rerender items after the item positions resizing
        if (listRef.current) {
            listRef.current.resetAfterIndex(index);
        }
    };
    return (React.createElement(List, { ref: listRef, style: menuListStyle, outerRef: innerRef, estimatedItemSize: Math.floor(totalMenuHeight / itemCount), className: classNamePrefix
            ? classNamePrefix + "__menu-list" + (isMulti ? " " + classNamePrefix + "__menu-list--is-multi" : '')
            : '', width: "100%", height: Math.min(maxHeight, totalMenuHeight + paddingBottom + paddingTop), itemCount: itemCount, itemSize: function (index) { return itemHeights[index]; }, initialScrollOffset: initialOffset }, function (_a) {
        var index = _a.index, style = _a.style;
        return (React.createElement(Item, { index: index, lss: style, setItemHeights: handleSetItemHeights }, children && children[index] ? children[index] : children));
    }));
};
export var optimizedFilter = createFilter({ ignoreAccents: false });
//# sourceMappingURL=OptimizedComponents.js.map